import { render, staticRenderFns } from "./CurrentActivityCard.vue?vue&type=template&id=912a15ae&scoped=true"
import script from "./CurrentActivityCard.vue?vue&type=script&lang=js"
export * from "./CurrentActivityCard.vue?vue&type=script&lang=js"
import style0 from "./CurrentActivityCard.vue?vue&type=style&index=0&id=912a15ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912a15ae",
  null
  
)

export default component.exports